import React from "react";
import {connect} from "dva";
import {component_tool,framework_tool} from '@/tool';
import {reduxTemplateConfig, templateConfig} from './config';

import {authDisableEnum, personStateEnum, stateEnum, getDealerList} from "../util";

let {WizBrowserExport, WizButton} = component_tool
let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;

class Index extends WizContainer {
  componentName = 'AccountConsolidationManager';

  constructor(props) {
    super(props);
    this.state={}
  }

  _componentDidMount() {
    console.log('_componentDidMount', this)
    const {form} = this
    const {resetFields} = form || {}

    const element = document.getElementsByClassName("search-btns")[0];
    const search_btns = element.getElementsByTagName('button');

    search_btns[0].click();

    search_btns[1].onclick = (e) => {
      e.stopPropagation();

      resetFields && resetFields();
      search_btns[0].click();
    };
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '账号合并管理',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '新账号',
        field: 'personInfoNew_userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '新账号姓名',
        field: 'personInfoNew_fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '新账号经销商',
        field: 'personInfoNew_dealer',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '新账号经任职',
        field: 'personInfoNew_identityList',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '旧账号',
        field: 'personInfoOld_userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '旧账号姓名',
        field: 'personInfoOld_fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '旧账号经销商',
        field: 'personInfoOld_dealer',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '旧账号经任职',
        field: 'personInfoOld_identityList',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '申请人姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '生成时间',
        field: 'createTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '申请时间',
        field: 'submitTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'state',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]



    if (o['success']) {
      let data = Object.assign([], o['data'])
      data.forEach((val, index) => {
        let keys = ['personInfoOld', 'personInfoNew']
        for (let key of keys) {
          let personInfo = val[key]
          for (let personInfo_key of Object.keys(personInfo)) {
            let value = personInfo[personInfo_key]
            if(personInfo_key === 'state') {
              value = personStateEnum[value]
            } else if(personInfo_key === 'disabled') {
              value = authDisableEnum[value]
            } else if(personInfo_key === 'identityList') {
              let dealerList = getDealerList(value);
              val[`${key}_dealer`] = dealerList?.map(data => `${[data?.preSalesNumber, data.afterSalesNumber].filter(item => !!item).join("_")}-${data?.name}`)?.join("、")
              value = value?.map(data => `${data?.orgName}-${data?.positionName}`)?.join('、')
            }
            val[`${key}_${personInfo_key}`] = value
          }
        }
        val.state = val.processState === 2 ? '已合并' : stateEnum[val.state]


        console.log('val', val)

      })
      WizBrowserExport({
        title: '账号合并管理',
        sheetName: '账号合并管理',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '账号合并管理.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _audit(nextProps, nextState, key) {
    let {success, msg, data} = nextProps[key]
    if (success) {
      wizNotice.success("操作成功");
    } else {
      wizNotice.error(msg);
    }
    this?.changeModal && this.changeModal(false, true, true)
    return true;
  }


  _render() {
    let _templateConfig = templateConfig(this)
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: this._handleFile.bind(this),
        audit: this._audit.bind(this)
      },
    });

    return (
      <WizReduxTemplate {..._reduxTemplateConfig} />
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const {} = state;
  return {
  }
};

export default connect(mapStateToProps)(Index);
